import Vue from 'vue'
import Router from 'vue-router'
import parentComponent from '@/pages/parentComponent'
Vue.use(Router)

// 路由建立优先级：流程优先，模块递减，公共组件类根据UI设计定
export default new Router({
    //	mode: 'history',
    routes: [{
            path: '',
            component: parentComponent,
            children: [
                { path: '', name: 'home', component: resolve => require(['../pages/auction/home.vue'], resolve), meta: { title: '首页', requireAuth: false, keepAlive: true } },
                { path: 'community', name: 'community', component: resolve => require(['../pages/community/community.vue'], resolve), meta: { title: '社区', requireAuth: false, keepAlive: true } },
                { path: 'information', name: 'information', component: resolve => require(['../pages/information/information.vue'], resolve), meta: { title: '资讯', requireAuth: false, keepAlive: true } },
                { path: 'user', name: 'user', component: resolve => require(['../pages/user/user.vue'], resolve), meta: { title: '个人中心', requireAuth: false, keepAlive: false } },
                { path: 'mall', name: 'mall', component: resolve => require(['../pages/mall/mall.vue'], resolve), meta: { title: '商城', requireAuth: false, keepAlive: true } },

            ]
        },

        //		拍卖模块----------------------------------------------------------------------------------------start

        // 拍场列表
        {
            path: '/session',
            component: parentComponent,
            children: [{
                    path: 'history',
                    name: 'historySession',
                    component: resolve => require(['../pages/auction/list/listPages.vue'], resolve),
                    meta: {
                        title: '历史拍场',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                {
                    path: 'preview',
                    name: 'previewSession',
                    component: resolve => require(['../pages/auction/list/listPages.vue'], resolve),
                    meta: {
                        title: '预展专区',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                {
                    path: 'hot',
                    name: 'hotSession',
                    component: resolve => require(['../pages/auction/list/listPages.vue'], resolve),
                    meta: {
                        title: '正在热拍',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                }
            ]
        },
        // 拍品
        {
            path: '/goods',
            component: parentComponent,
            children: [
                // 历史拍卖（拍卖专场的，不包含每日一拍的历史）
                {
                    path: 'history',
                    name: 'history',
                    component: resolve => require(['../pages/auction/list/listGoods.vue'], resolve),
                    meta: {
                        title: '历史拍品',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },

                // 推荐收藏
                {
                    path: 'pick',
                    name: 'pick',
                    component: resolve => require(['../pages/auction/list/listGoods.vue'], resolve),
                    meta: {
                        title: '推荐收藏',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                // 产地分类
                {
                    path: 'chanDi',
                    name: 'chanDi',
                    component: resolve => require(['../pages/auction/list/listGoods.vue'], resolve),
                    meta: {
                        title: '分类',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                // 选择拍品列表（3.1.3新版的交保证金列表）
                {
                    path: 'payDeposit',
                    name: 'payDeposit',
                    component: resolve => require(['../pages/auction/list/chooseLIst.vue'], resolve),
                    meta: {
                        requireAuth: true,
                        title: '交保证金'
                    },
                },
                {
                    path: 'mySale',
                    name: 'mySale',
                    component: resolve => require(['../pages/user/mySale.vue'], resolve),
                    meta: {
                        title: '我的竞拍',
                        requireAuth: true,
                        keepAlive: true,
                        isBack: false
                    },
                }

            ]
        },
        //详情
        {
            path: '/detail',
            component: parentComponent,
            children: [
                // 拍场详情    seq---拍场seq
                { path: 'auctionGroup/:seq', name: 'auctionGroup', component: resolve => require(['../pages/auction/detail/auctionGroup.vue'], resolve), meta: { title: '拍场详情', requireAuth: false, keepAlive: true, isBack: false } },
                //直播图文详情
                // { path: 'auctionGroup/:seq', name: 'auctionGroup', component: resolve => require(['../pages/auction/detail/auctionGroup.vue'], resolve), meta: {title: '拍场详情', requireAuth: false, keepAlive: true,isBack:false}},
                // 拍品详情
                {
                    path: 'good/:sessionSeq/:goodsSeq',
                    name: 'goodsDetail',
                    component: resolve => require(['../pages/auction/detail/good.vue'], resolve),
                    meta: {
                        title: '拍品详情',
                        requireAuth: false,
                        noDownload: true
                    }
                },
                // 拍品出价记录   Gseq---拍品seq
                {
                    path: 'record/:Gseq',
                    name: 'record',
                    component: resolve => require(['../pages/auction/detail/record/record.vue'], resolve),
                    meta: {
                        title: '出价记录',
                        requireAuth: true
                    }
                }

            ]
        },
        // 订单
        {
            path: '/order',
            component: parentComponent,
            children: [
                // 拍卖订单
                {
                    path: 'saleOrder',
                    name: 'saleOrder',
                    component: resolve => require(['../pages/auction/order/saleOrder.vue'], resolve),
                    meta: {
                        title: '拍卖订单',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                // 违约订单
                {
                    path: 'saleBreakOrder',
                    name: 'saleBreakOrder',
                    component: resolve => require(['../pages/auction/order/saleBreakOrder.vue'], resolve),
                    meta: {
                        title: '违约单',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                // 填写订单
                {
                    path: 'checkout',
                    name: 'checkout',
                    component: resolve => require(['../pages/auction/order/checkout.vue'], resolve),
                    meta: {
                        title: '填写订单',
                        requireAuth: true
                    }
                },
                // 订单详情    seq---订单seq
                {
                    path: 'orderDetail/:seq',
                    name: 'orderDetail',
                    component: resolve => require(['../pages/auction/order/detail.vue'], resolve),
                    meta: {
                        title: '订单详情',
                        requireAuth: true
                    }
                },

            ]
        },
        //		拍卖模块----------------------------------------------------------------------------------------end
        {
            path: '/pay',
            component: parentComponent,
            children: [{
                    path: 'boon',
                    name: 'boonPay',
                    component: resolve => require(['../pages/pay/pay.vue'], resolve),
                    meta: {
                        title: '支付中心',
                        requireAuth: true
                    }
                },
                {
                    path: 'salePay',
                    name: 'salePay',
                    component: resolve => require(['../pages/pay/pay.vue'], resolve),
                    meta: {
                        title: '支付中心',
                        requireAuth: true
                    }
                },
                {
                    path: 'communityPay',
                    name: 'communityPay',
                    component: resolve => require(['../pages/pay/pay.vue'], resolve),
                    meta: {
                        title: '支付中心',
                        requireAuth: true
                    }
                },
                {
                    path: 'bottlePay',
                    name: 'bottlePay',
                    component: resolve => require(['../pages/pay/pay.vue'], resolve),
                    meta: {
                        title: '支付中心',
                        requireAuth: true
                    }
                },
                {
                    path: 'auctionRule',
                    name: 'auctionRule',
                    component: resolve => require(['../components/text/auctionRule.vue'], resolve),
                    meta: {
                        title: '拍卖规则',
                        requireAuth: false
                    }
                },
                {
                    path: 'offlinePay',
                    name: 'offlinePay',
                    component: resolve => require(['../components/text/offlinePay.vue'], resolve),
                    meta: {
                        title: '线下支付',
                        requireAuth: false
                    }
                },
            ]
        },

        // 商城模块--------------------------------------------------------------------------------------------------start
        {
            path: '/mallBox',
            component: parentComponent,
            children: [{
                    path: 'search',
                    name: 'searchd',
                    component: resolve => require(['../pages/mall/search/search.vue'], resolve),
                    meta: {
                        title: '',
                        requireAuth: false
                    }
                },
                {
                    path: 'allMall',
                    name: 'allMall',
                    component: resolve => require(['../pages/mall/allMall/allMall.vue'], resolve),
                    meta: {
                        title: '全部商品',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                {
                    path: 'commonEvent/:code',
                    name: 'commonEvent',
                    component: resolve => require(['../pages/mall/event/commonEvent.vue'], resolve),
                    meta: {
                        title: ' ',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false,
                        isShare: true
                    }
                },
                {
                    path: 'allBlind',
                    name: 'allBlind',
                    component: resolve => require(['../pages/mall/allMall/allBlind.vue'], resolve),
                    meta: {
                        title: '盲品活动',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
                { // 微信扫价签 进入的商品详情页 单独处理 不需要展示商品价格等复杂的逻辑信息
                    path: 'goodsDetails/:goodsCode/:type',
                    name: 'goodsDetails',
                    component: resolve => require(['../pages/mall/goodsDetails/goodsDetails'], resolve),
                    meta: {
                        title: '商品详情',
                        requireAuth: false
                    }
                },
                {
                    path: 'mallDetails1/:id',
                    name: 'mallDetails1',
                    component: resolve => require(['../pages/mall/mallDetails/mallDetails.vue'], resolve),
                    meta: {
                        title: '商品详情',
                        requireAuth: false
                    }
                },
                {
                    // path: 'mallDetails/:goodsCode/:type',
                    path: 'mallDetails/:goodsCode/:type',
                    name: 'mallDetails',
                    component: resolve => require(['../pages/mall/mallDetails/new-mallDetails.vue'], resolve),
                    meta: {
                        title: '商品详情',
                        requireAuth: false,
                        hideTitle: true
                    }
                },
                //直播限时抽奖
                {
                    path: '/liveLottery/:id/:k',
                    name: 'liveLottery',
                    component: resolve => require(['../pages/live/liveLottery.vue'], resolve),
                    meta: {
                        title: '限时抽奖',
                        requireAuth: false,
                        isShare: true
                    }
                },
                {
                    path: 'allLimitedTime',
                    name: 'allLimitedTime',
                    component: resolve => require(['../pages/mall/allMall/allLimitedTime.vue'], resolve),
                    meta: {
                        title: '限时抢购',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                            //isShare:true
                    }
                },
                {
                    path: 'allSpecialEvent',
                    name: 'allSpecialEvent',
                    component: resolve => require(['../pages/mall/allMall/allSpecialEvent.vue'], resolve),
                    meta: {
                        title: '专题活动',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                            //isShare:true
                    }
                },
                {
                    path: 'productReview/:id',
                    name: 'productReview',
                    component: resolve => require(['../pages/mall/mallDetails/productReview.vue'], resolve),
                    meta: {
                        title: '商品评价',
                        requireAuth: false
                    }
                },
                {
                    path: 'groupBuy',
                    name: 'groupBuy',
                    component: resolve => require(['../pages/mall/groupBuy.vue'], resolve),
                    meta: {
                        title: '拼团人数',
                        requireAuth: true
                    }
                },
                {
                    path: 'shoppingBag',
                    name: 'shoppingBag',
                    component: resolve => require(['../pages/mall/shoppingBag.vue'], resolve),
                    meta: {
                        title: '购物车',
                        requireAuth: true
                    }
                },
                {
                    path: 'rockResult',
                    name: 'rockResult',
                    component: resolve => require(['../pages/mall/rockResult.vue'], resolve),
                    meta: {
                        title: '摇号结果',
                        requireAuth: true
                    }
                },
                {
                    path: 'mallOrder',
                    name: 'mallOrder',
                    component: resolve => require(['../pages/mall/mallOrder/mallOrder.vue'], resolve),
                    meta: {
                        title: '商城订单',
                        requireAuth: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                {
                    path: 'mallOrderDetail/:id',
                    name: 'mallOrderDetail',
                    component: resolve => require(['../pages/mall/mallOrder/mallOrderDetail.vue'], resolve),
                    meta: {
                        title: '订单详情',
                        requireAuth: true
                    }
                },
                {
                    path: 'afterSaleServe',
                    name: 'afterSaleServe',
                    component: resolve => require(['../pages/mall/mallOrder/afterSaleServe.vue'], resolve),
                    meta: {
                        title: '售后服务',
                        requireAuth: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                {
                    path: 'applyRefund/:id',
                    name: 'applyRefund',
                    component: resolve => require(['../pages/mall/mallOrder/applyRefund.vue'], resolve),
                    meta: {
                        title: '申请退款',
                        requireAuth: true
                    }
                },
                {
                    path: 'refundDetail/:id',
                    name: 'refundDetail',
                    component: resolve => require(['../pages/mall/mallOrder/refundDetail.vue'], resolve),
                    meta: {
                        title: '退款详情',
                        requireAuth: true
                    }
                },
                {
                    path: 'mallCheckOut',
                    name: 'mallCheckOut',
                    component: resolve => require(['../pages/mall/checkout.vue'], resolve),
                    meta: {
                        title: '填写订单',
                        requireAuth: true
                    }
                },
                {
                    path: 'mallPay',
                    name: 'mallPay',
                    component: resolve => require(['../pages/mall/mallPay/mallPay.vue'], resolve),
                    meta: {
                        title: '商城支付',
                        requireAuth: true
                    }
                },
                {
                    path: 'voucherActive/:id',
                    name: 'voucherActive',
                    component: resolve => require(['../components/knight/CouponReminder.vue'], resolve),
                    meta: {
                        title: '提示',
                        requireAuth: false
                    }
                },
                //商城专题活动路由
                {
                    path: 'tullibardine',
                    name: 'tullibardine',
                    component: resolve => require(['../pages/mall/newEvent/tullibardine.vue'], resolve),
                    meta: {
                        title: '杜丽巴汀系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'wholeBoxSale',
                    name: 'wholeBoxSale',
                    component: resolve => require(['../pages/mall/newEvent/wholeBoxSale.vue'], resolve),
                    meta: {
                        title: '中秋特惠',
                        isShare: true
                    }
                },
                {
                    path: 'wholeBox03',
                    name: 'wholeBox03',
                    component: resolve => require(['../pages/mall/newEvent/wholeBox03.vue'], resolve),
                    meta: {
                        title: '中秋特惠',
                        isShare: true
                    }
                },
                {
                    path: 'combinationSale',
                    name: 'combinationSale',
                    component: resolve => require(['../pages/mall/newEvent/combinationSale.vue'], resolve),
                    meta: {
                        title: '超值组合',
                        isShare: true
                    }
                },
                {
                    path: 'bruichladdich',
                    name: 'bruichladdich',
                    component: resolve => require(['../pages/mall/newEvent/bruichladdich.vue'], resolve),
                    meta: {
                        title: '布赫拉迪系列威士忌',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'newYearGoods',
                    name: 'newYearGoods',
                    component: resolve => require(['../pages/mall/newEvent/newYearGoods.vue'], resolve),
                    meta: {
                        title: '2021年货节',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'benromach',
                    name: 'benromach',
                    component: resolve => require(['../pages/mall/newEvent/benromach.vue'], resolve),
                    meta: {
                        title: '本诺曼克系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'singleton',
                    name: 'singleton',
                    component: resolve => require(['../pages/mall/newEvent/singleton.vue'], resolve),
                    meta: {
                        title: '苏格登系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'eventTemplate',
                    name: 'eventTemplate',
                    component: resolve => require(['../pages/mall/newEvent/eventTemplate.vue'], resolve),
                    meta: {
                        title: '日威系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'singlecask',
                    name: 'singlecask',
                    component: resolve => require(['../pages/mall/newEvent/singlecask.vue'], resolve),
                    meta: {
                        title: '单桶系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'ardbeg',
                    name: 'ardbeg',
                    component: resolve => require(['../pages/mall/newEvent/ardbeg.vue'], resolve),
                    meta: {
                        title: '阿贝系列威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'macphails',
                    name: 'macphails',
                    component: resolve => require(['../pages/mall/newEvent/macphails.vue'], resolve),
                    meta: {
                        title: '高登&麦克菲尔系列',
                        isShare: true
                    }
                },
                {
                    path: 'de',
                    name: 'de',
                    component: resolve => require(['../pages/mall/newEvent/de.vue'], resolve),
                    meta: {
                        title: 'DE酒厂限量版威士忌',
                        isShare: true
                    }
                },
                {
                    path: 'edradour',
                    name: 'edradour',
                    component: resolve => require(['../pages/mall/newEvent/edradour.vue'], resolve),
                    meta: {
                        title: '埃德拉多尔威士忌',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'goldward',
                    name: 'goldward',
                    component: resolve => require(['../pages/mall/newEvent/goldward.vue'], resolve),
                    meta: {
                        title: '5.19限时秒杀劲惠来袭！',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'collection',
                    name: 'collection',
                    component: resolve => require(['../pages/mall/newEvent/collection.vue'], resolve),
                    meta: {
                        title: '5.19狂撒福利享不停！',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'goldward2',
                    name: 'goldward2',
                    component: resolve => require(['../pages/mall/newEvent/goldward2.vue'], resolve),
                    meta: {
                        title: '五月聚惠福利全开',
                        isShare: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'seckill',
                    name: 'seckill',
                    component: resolve => require(['../pages/mall/newEvent/seckill.vue'], resolve),
                    meta: {
                        title: '兔年新礼遇限时优惠',
                        isShare: true,
                        keepAlive: true
                    }
                },{
                    path: 'sevenGo',
                    name: 'sevenGo',
                    component: resolve => require(['../pages/mall/newEvent/sevenGo.vue'], resolve),
                    meta: {
                        title: '七夕乐购嗨翻天',
                        isShare: true,
                        keepAlive: true
                    }
                },{
                    path: 'nineGo',
                    name: 'nineGo',
                    component: resolve => require(['../pages/mall/newEvent/nineGo.vue'], resolve),
                    meta: {
                        title: '99划算节来袭',
                        isShare: true,
                        keepAlive: true
                    }
                },{
                    path: 'double11',
                    name: 'double11',
                    component: resolve => require(['../pages/mall/newEvent/double11.vue'], resolve),
                    meta: {
                        title: '双11盛会齐聚',
                        isShare: true,
                        keepAlive: true
                    }
                },{
                    path: 'double12',
                    name: 'double12',
                    component: resolve => require(['../pages/mall/newEvent/double12.vue'], resolve),
                    meta: {
                        title: '年终狂欢 盛惠不打烊',
                        isShare: true,
                        keepAlive: true
                    }
                },{
                    path: 'newYear',
                    name: 'newYear',
                    component: resolve => require(['../pages/mall/newEvent/newYear.vue'], resolve),
                    meta: {
                        title: '欢庆双旦，盛惠开启！',
                        isShare: true,
                        keepAlive: true
                    }
                }
            ]
        },
        // 商城模块--------------------------------------------------------------------------------------------------end

        // 社区模块--------------------------------------------------------------------------------------------------start
        {
            path: '/communityBox',
            component: parentComponent,
            children: [
                //搜索页
                {
                    path: 'communitySeach',
                    name: 'communitySeach',
                    component: resolve => require(['../pages/common/search/search.vue'], resolve),
                    meta: {
                        title: '搜索',
                        requireAuth: false
                    }
                },
                //云品鉴海报
                {
                    path: 'cloudPost',
                    name: 'cloudPost',
                    component: resolve => require(['../pages/live/cloudPost.vue'], resolve),
                    meta: {
                        title: '云品鉴',
                        requireAuth: false,
                        isShare: true
                    }
                },

                {
                    path: 'communityDetail',
                    name: 'communityDetail',
                    component: resolve => require(['../pages/community/detail.vue'], resolve),
                    meta: {
                        title: '帖子详情',
                        requireAuth: false
                    }
                },
                //酒评款详情   puid---productId
                {
                    path: 'drinkDetail',
                    name: 'drinkDetail',
                    component: resolve => require(['../pages/community/drinkDetail.vue'], resolve),
                    meta: {
                        title: '酒评列表',
                        requireAuth: false,
                        keepAlive: true
                    }
                },
                //专用空瓶详情
                {
                    path: 'bottleDetail',
                    name: 'bottleDetail',
                    component: resolve => require(['../pages/community/bottleDetail.vue'], resolve),
                    meta: {
                        title: '专用瓶详情',
                        requireAuth: false
                    }
                },
                //打赏榜单
                {
                    path: 'rewardList',
                    name: 'rewardList',
                    component: resolve => require(['../pages/community/rewardList.vue'], resolve),
                    meta: {
                        title: '打赏榜单',
                        requireAuth: false
                    }
                },
                //发帖子用户
                {
                    path: 'publisher/:seq',
                    name: 'publisher',
                    component: resolve => require(['../pages/community/description.vue'], resolve),
                    meta: {
                        title: '个人主页',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false,
                        isShare: true,
                        shareImg: true,
                        isShareImg: true
                    }
                },
                //新酒评帖
                {
                    path: 'newWineReview/:seq',
                    name: 'newWineReview',
                    component: resolve => require(['../pages/user/postKit/newWineReview.vue'], resolve),
                    meta: {
                        title: '酒评帖',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                // 分享吧订单
                {
                    path: 'shareOrder',
                    name: 'shareOrder',
                    component: resolve => require(['../pages/community/shareOrder.vue'], resolve),
                    meta: {
                        title: '分享吧订单',
                        requireAuth: true,
                        keepAlive: true,
                        keepHeight: true
                    }
                },
                // 专用瓶订单
                {
                    path: 'SpecialOrder',
                    name: 'SpecialOrder',
                    component: resolve => require(['../pages/community/shareOrder.vue'], resolve),
                    meta: {
                        title: '专用瓶订单',
                        requireAuth: true,
                        keepHeight: true
                    }
                },
                // 帖子填写订单（如果是从帖子详情点击立即参与就进入这里，如果是从待支付订单的话直接进入到结算台）
                {
                    path: 'communityCheckout',
                    name: 'communityCheckout',
                    component: resolve => require(['../pages/community/checkout.vue'], resolve),
                    meta: {
                        title: '填写订单',
                        requireAuth: true
                    }
                },
            ]
        },
        // 社区模块--------------------------------------------------------------------------------------------------end

        //资讯模块---------------------------------------------------------------------------strart
        {
            path: '/informationBox',
            component: parentComponent,
            children: [{
                    path: 'informationDetail/:id',
                    name: 'informationDetail',
                    component: resolve => require(['../pages/information/informationDetail.vue'], resolve),
                    meta: {
                        title: '资讯详情',
                        requireAuth: false
                    }
                },
                {
                    path: 'videoDetail/:id',
                    name: 'videoDetail',
                    component: resolve => require(['../pages/information/videoDetail.vue'], resolve),
                    meta: {
                        title: '资讯详情',
                        requireAuth: false
                    }
                }
            ]
        },
        //资讯模块---------------------------------------------------------------------------end
        //个人中心模块---------------------------------------------------------------------------strart
        {
            path: '/userBox',
            component: parentComponent,
            children: [
                //我的关注
                {
                    path: 'myFollow',
                    name: 'myFollow',
                    component: resolve => require(['../pages/user/myFollow.vue'], resolve),
                    meta: {
                        title: '关注列表',
                        requireAuth: false,
                        keepHeight: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                //我的粉丝
                {
                    path: 'myFollower',
                    name: 'myFollower',
                    component: resolve => require(['../pages/user/myFollow.vue'], resolve),
                    meta: {
                        title: '粉丝列表',
                        requireAuth: false,
                        keepHeight: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                //我的帖子
                {
                    path: 'myCommunity',
                    name: 'myCommunity',
                    component: resolve => require(['../pages/user/postKit/newMyCommunity.vue'], resolve),
                    meta: {
                        title: '我的帖子',
                        requireAuth: true,
                        keepAlive: false
                    }
                },
                //酒评帖
                {
                    path: 'WineReview',
                    name: 'WineReview',
                    component: resolve => require(['../pages/user/postKit/WineReview.vue'], resolve),
                    meta: {
                        title: '我的帖子',
                        requireAuth: true,
                        keepAlive: true
                    }
                },

                //我的收藏
                {
                    path: 'myCollect',
                    name: 'myCollect',
                    component: resolve => require(['../pages/user/myCollect.vue'], resolve),
                    meta: {
                        title: '我的收藏',
                        requireAuth: true,
                        keepHeight: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                //我的足迹
                {
                    path: 'myFootstep',
                    name: 'myFootstep',
                    component: resolve => require(['../pages/user/myFootstep.vue'], resolve),
                    meta: {
                        title: '我的足迹',
                        requireAuth: true,
                        keepHeight: true,
                        keepAlive: true,
                        isBack: false
                    }
                },
                //我的钱包
                {
                    path: 'myPurse',
                    name: 'myPurse',
                    component: resolve => require(['../pages/user/myPurse.vue'], resolve),
                    meta: {
                        title: '我的钱包',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                //我的积分
                {
                    path: 'myIntegral',
                    name: 'myIntegral',
                    component: resolve => require(['../pages/user/myIntegral.vue'], resolve),
                    meta: {
                        title: '我的积分',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'IntegralRules',
                    name: 'IntegralRules',
                    component: resolve => require(['../components/text/IntegralRules.vue'], resolve),
                    meta: {
                        title: '积分规则',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'couponRules',
                    name: 'couponRules',
                    component: resolve => require(['../components/text/couponRules.vue'], resolve),
                    meta: {
                        title: '优惠券使用规则',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'mallVoucher',
                    name: 'mallVoucher',
                    component: resolve => require(['../pages/mall/mallVoucher/mallVoucher.vue'], resolve),
                    meta: {
                        title: '优惠券',
                        requireAuth: true
                    }
                },
                {
                    path: 'VoucherCenter',
                    name: 'VoucherCenter',
                    component: resolve => require(['../pages/mall/mallVoucher/VoucherCenter.vue'], resolve),
                    meta: {
                        title: '领券中心',
                        requireAuth: true
                    }
                },

                //个人信息页面
                {
                    path: 'personalDetails',
                    name: 'personalDetails',
                    component: resolve => require(['../pages/user/personalDetails.vue'], resolve),
                    meta: {
                        title: '个人信息',
                        requireAuth: true
                    }
                },
                //个人信息中的子页面（编辑页）
                {
                    path: 'edit',
                    component: parentComponent,
                    children: [{
                            path: 'realName',
                            name: 'realName',
                            component: resolve => require(['../pages/user/edit/realName.vue'], resolve),
                            meta: {
                                title: '姓名',
                                requireAuth: true
                            }
                        },
                        {
                            path: 'nickName',
                            name: 'nickName',
                            component: resolve => require(['../pages/user/edit/nickName.vue'], resolve),
                            meta: {
                                title: '昵称',
                                requireAuth: true
                            }
                        },
                        {
                            path: 'autograph',
                            name: 'autograph',
                            component: resolve => require(['../pages/user/edit/autograph.vue'], resolve),
                            meta: {
                                title: '设置个性签名',
                                requireAuth: true
                            }
                        },
                        {
                            path: 'customerEmail',
                            name: 'customerEmail',
                            component: resolve => require(['../pages/user/edit/customerEmail.vue'], resolve),
                            meta: {
                                title: '绑定邮箱',
                                requireAuth: true
                            }
                        },
                        {
                            path: 'replace',
                            name: 'replace',
                            component: resolve => require(['../pages/login/replace.vue'], resolve),
                            meta: {
                                title: '修改登录密码',
                                requireAuth: false
                            }
                        }
                    ]
                },
                //个人设置页面
                {
                    path: 'personalSetting',
                    name: 'personalSetting',
                    component: resolve => require(['../pages/user/personalSetting.vue'], resolve),
                    meta: {
                        title: '个人设置',
                        requireAuth: true
                    }
                },


                // 拍卖指南列表页
                {
                    path: 'auctionGuide',
                    name: 'auctionGuide',
                    component: resolve => require(['../pages/user/setting/settingList.vue'], resolve),
                    meta: {
                        title: '拍卖指南',
                        requireAuth: false,
                    }
                },
                // 支付方式列表页
                {
                    path: 'paymentMethod',
                    name: 'paymentMethod',
                    component: resolve => require(['../pages/user/setting/settingList.vue'], resolve),
                    meta: {
                        title: '支付方式',
                        requireAuth: false
                    }
                },
                // 售后服务列表页
                {
                    path: 'afterSalesService',
                    name: 'afterSalesService',
                    component: resolve => require(['../pages/user/setting/settingList.vue'], resolve),
                    meta: {
                        title: '售后服务',
                        requireAuth: false
                    }
                },
                //关于
                {
                    path: 'Our',
                    name: 'Our',
                    component: resolve => require(['../pages/user/setting/out.vue'], resolve),
                    meta: {
                        title: '关于',
                        requireAuth: true
                    }
                },
                //意见反馈
                {
                    path: 'Feedback',
                    name: 'Feedback',
                    component: resolve => require(['../pages/user/setting/Feedback.vue'], resolve),
                    meta: {
                        title: '意见反馈',
                        requireAuth: true
                    }
                },
                //拍卖征集广告
                {
                    path: 'collect',
                    name: 'collect',
                    component: resolve => require(['../components/text/aboutSetting/direction/collect.vue'], resolve),
                    meta: {
                        title: '拍卖征集广告',
                        requireAuth: false
                    }
                },
                //拍卖法
                {
                    path: 'auctionMethod',
                    name: 'auctionMethod',
                    component: resolve => require(['../components/text/aboutSetting/direction/auctionMethod.vue'], resolve),
                    meta: {
                        title: '拍卖法',
                        requireAuth: false
                    }
                },
                //拍卖规则
                {
                    path: 'rule',
                    name: 'rule',
                    component: resolve => require(['../components/text/aboutSetting/direction/rule.vue'], resolve),
                    meta: {
                        title: '拍卖规则',
                        requireAuth: false
                    }
                },

                //送拍须知
                {
                    path: 'notice',
                    name: 'notice',
                    component: resolve => require(['../components/text/aboutSetting/direction/notice.vue'], resolve),
                    meta: {
                        title: '送拍须知',
                        requireAuth: false
                    }
                },

                //发票说明
                {
                    path: 'InvoiceDescription',
                    name: 'InvoiceDescription',
                    component: resolve => require(['../components/text/aboutSetting/payType/InvoiceDescription.vue'], resolve),
                    meta: {
                        title: '发票说明',
                        requireAuth: false
                    }
                },
                //在线支付
                {
                    path: 'upPay',
                    name: 'upPay',
                    component: resolve => require(['../components/text/aboutSetting/payType/upPay.vue'], resolve),
                    meta: {
                        title: '在线支付',
                        requireAuth: false
                    }
                },
                //线下支付
                {
                    path: 'downPay',
                    name: 'downPay',
                    component: resolve => require(['../components/text/aboutSetting/payType/downPay.vue'], resolve),
                    meta: {
                        title: '线下支付',
                        requireAuth: false
                    }
                },
                //配送说明
                {
                    path: 'distribution',
                    name: 'distribution',
                    component: resolve => require(['../components/text/aboutSetting/afterSales/distribution.vue'], resolve),
                    meta: {
                        title: '配送说明',
                        requireAuth: false
                    }
                },
                //常见问题
                {
                    path: 'problem',
                    name: 'problem',
                    component: resolve => require(['../components/text/aboutSetting/afterSales/problem.vue'], resolve),
                    meta: {
                        title: '常见问题',
                        requireAuth: false
                    }
                },
                //退换货政策
                {
                    path: 'returnText',
                    name: 'returnText',
                    component: resolve => require(['../components/text/aboutSetting/afterSales/returnText.vue'], resolve),
                    meta: {
                        title: '退换货政策',
                        requireAuth: false
                    }
                },
                //品质保障
                {
                    path: 'ensure',
                    name: 'ensure',
                    component: resolve => require(['../components/text/aboutSetting/afterSales/ensure.vue'], resolve),
                    meta: {
                        title: '品质保障',
                        requireAuth: false
                    }
                },
                //关于我们
                {
                    path: 'aboutUS',
                    name: 'aboutUS',
                    component: resolve => require(['../components/text/aboutSetting/about/aboutUS.vue'], resolve),
                    meta: {
                        title: '关于我们',
                        requireAuth: false
                    }
                },
            ]
        },
        //个人中心模块---------------------------------------------------------------------------end


        //文案模块（后续把模块下的文案模块也挪进来，待优化）
        {
            path: '/text',
            component: parentComponent,
            children: [
                //普通拼团规则
                {
                    path: 'pintuanRules01',
                    name: 'pintuanRules01',
                    component: resolve => require(['../components/text/pintuanRules01.vue'], resolve),
                    meta: {
                        title: '拼团规则',
                        requireAuth: false
                    }
                },
                //阶梯拼团规则
                {
                    path: 'pintuanRules02',
                    name: 'pintuanRules02',
                    component: resolve => require(['../components/text/pintuanRules02.vue'], resolve),
                    meta: {
                        title: '拼团规则',
                        requireAuth: false
                    }
                },
                //摇号规则
                {
                    path: 'lotteryRules',
                    name: 'lotteryRules',
                    component: resolve => require(['../components/text/lotteryRules.vue'], resolve),
                    meta: {
                        title: '摇号规则',
                        requireAuth: false
                    }
                },
                {
                    path: 'communityRules',
                    name: 'communityRules',
                    component: resolve => require(['../components/text/communityRules.vue'], resolve),
                    meta: {
                        title: '中威网社区规则',
                        requireAuth: false
                    }
                },
                //commissionAuctionContract
                {
                    path: 'commissionAuctionContract',
                    name: 'commissionAuctionContract',
                    component: resolve => require(['../components/text/commissionAuctionContract.vue'], resolve),
                    meta: {
                        title: '委托拍卖合同',
                        requireAuth: false
                    }
                },
                //送拍声明书
                {
                    path: 'sendInstructions',
                    name: 'sendInstructions',
                    component: resolve => require(['../components/text/aboutSetting/direction/sendInstructions.vue'], resolve),
                    meta: {
                        title: '送拍声明书',
                        requireAuth: false
                    }
                },
                {
                    path: 'increaseRule',
                    name: 'increaseRule',
                    component: resolve => require(['../components/text/increaseRule.vue'], resolve),
                    meta: {
                        title: '加价规则',
                        requireAuth: false
                    }
                },
                {
                    path: 'biddingProtocol',
                    name: 'biddingProtocol',
                    component: resolve => require(['../components/text/biddingProtocol.vue'], resolve),
                    meta: {
                        title: '竞买协议',
                        requireAuth: false
                    }
                },
                //拍卖达人
                {
                    path: 'master',
                    name: 'master',
                    component: resolve => require(['../components/text/master.vue'], resolve),
                    meta: {
                        title: '拍卖达人',
                        requireAuth: true
                    }
                },
                //许可证
                {
                    path: 'license',
                    name: 'license',
                    component: resolve => require(['../components/text/license.vue'], resolve),
                    meta: {
                        title: '许可证',
                        requireAuth: false
                    }
                },
                {
                    path: 'download',
                    name: 'download',
                    component: resolve => require(['../components/text/newDownload.vue'], resolve),
                    meta: {
                        title: 'APP下载',
                        requireAuth: false
                    }
                },
                //众筹规则
                {
                    path: 'crowdfundingRules',
                    name: 'crowdfundingRules',
                    component: resolve => require(['../components/text/crowdfundingRules.vue'], resolve),
                    meta: {
                        title: '众筹规则',
                        requireAuth: true
                    }
                },
                //抽奖规则
                {
                    path: 'sweepstakesRules',
                    name: 'sweepstakesRules',
                    component: resolve => require(['../components/text/sweepstakesRules.vue'], resolve),
                    meta: {
                        title: '抽奖规则',
                        requireAuth: true
                    }
                },
                //定制流程说明
                {
                    path: 'customDetailsTxt/:id',
                    name: 'customDetailsTxt',
                    component: resolve => require(['../components/text/customDetailsTxt.vue'], resolve),
                    meta: {
                        title: '定制流程',
                        requireAuth: false
                    }
                },
            ]
        },
        // 以下是兼容N年前物料上的老二维码地址
        {
            path: '/html/dowloadApp.html',
            name: '/html/dowloadApp.html',
            component: resolve => require(['../components/text/newDownload.vue'], resolve),
            meta: {
                title: 'APP下载',
                requireAuth: false
            }
        },
        // 所有模块公用的，比如地址管理，物流，发票等
        {
            path: '/common',
            component: parentComponent,
            children: [
                // 发票
                {
                    path: 'invoice',
                    name: 'invoice',
                    component: resolve => require(['../pages/common/invoice.vue'], resolve),
                    meta: {
                        title: '发票',
                        requireAuth: true
                    }
                },
                // 发票
                {
                    path: 'invoiceQualification',
                    name: 'invoiceQualification',
                    component: resolve => require(['../pages/common/invoiceQualification.vue'], resolve),
                    meta: {
                        title: '增票资质',
                        requireAuth: true
                    }
                },
                //新增,编辑增票资质
                {
                    path: 'invoiceForm',
                    name: 'invoiceForm',
                    component: resolve => require(['../pages/common/invoiceForm.vue'], resolve),
                    meta: {
                        title: '增票资质',
                        requireAuth: true
                    }
                },
                { //地址列表
                    path: 'addressList',
                    name: 'addressList',
                    component: resolve => require(['../pages/common/addressList.vue'], resolve),
                    meta: {
                        title: '收货地址',
                        requireAuth: true
                    }
                },
                { //地址管理
                    path: 'addressMent',
                    name: 'addressMent',
                    component: resolve => require(['../pages/common/addressMent.vue'], resolve),
                    meta: {
                        title: '管理地址',
                        requireAuth: true
                    }
                },
                { //添加地址
                    path: 'addressAdd',
                    name: 'addressAdd',
                    component: resolve => require(['../pages/common/addressEdit.vue'], resolve),
                    meta: {
                        title: '添加收货地址',
                        requireAuth: true
                    }
                },
                { //编辑地址   seq --- 地址seq
                    path: 'addressEdit',
                    name: 'addressEdit',
                    component: resolve => require(['../pages/common/addressEdit.vue'], resolve),
                    meta: {
                        title: '编辑收货地址',
                        requireAuth: true
                    }
                },
                //物流查询   Oseq---订单seq
                {
                    path: 'logistics',
                    name: 'logistics',
                    component: resolve => require(['../pages/common/logistics.vue'], resolve),
                    meta: {
                        title: '物流跟踪',
                        requireAuth: true
                    }
                },
                //搜索页
                {
                    path: 'search',
                    name: 'search',
                    component: resolve => require(['../pages/common/search/search.vue'], resolve),
                    meta: {
                        title: '搜索',
                        requireAuth: false
                    }
                },
                //搜索页
                {
                    path: 'result',
                    name: 'result',
                    component: resolve => require(['../pages/common/search/result.vue'], resolve),
                    meta: {
                        title: '搜索结果',
                        requireAuth: false,
                        keepAlive: true,
                        isBack: false
                    }
                },
            ]
        },
        {
            path: '/login',
            component: parentComponent,
            children: [{
                    path: '',
                    name: 'login',
                    component: resolve => require(['../pages/login/mesLogin.vue'], resolve),
                    meta: {
                        title: '登录',
                        requireAuth: false
                    }
                },
                {
                    path: 'mLogin',
                    name: 'mLogin',
                    component: resolve => require(['../pages/login/login.vue'], resolve),
                    meta: {
                        title: '密码登录',
                        requireAuth: false
                    }
                },
                {
                    path: 'register',
                    name: 'register',
                    component: resolve => require(['../pages/login/register.vue'], resolve),
                    meta: {
                        title: '账号注册',
                        requireAuth: false
                    }
                },
                {
                    path: 'userRegisterProtocol',
                    name: 'userRegisterProtocol',
                    component: resolve => require(['../components/text/userRegisterProtocol.vue'], resolve),
                    meta: {
                        title: '注册协议',
                        requireAuth: false
                    }
                },
                {
                    path: 'privacy',
                    name: 'privacy',
                    component: resolve => require(['../components/text/privacy.vue'], resolve),
                    meta: {
                        title: '隐私政策',
                        requireAuth: false
                    }
                },
                // 第三方货主app
                {
                    path: 'thirdPrivacy',
                    name: 'thirdPrivacy',
                    component: resolve => require(['../components/text/thirdPrivacy.vue'], resolve),
                    meta: {
                        title: '隐私政策',
                        requireAuth: false
                    }
                },
                {
                    path: 'thirdProtocol',
                    name: 'thirdProtocol',
                    component: resolve => require(['../components/text/thirdProtocol.vue'], resolve),
                    meta: {
                        title: '供货协议',
                        requireAuth: false
                    }
                }
            ]
        },
        {
            path: '/staticText',
            component: parentComponent,
            children: [{
                    path: 'purchaseContract',
                    name: 'purchaseContract',
                    component: resolve => require(['../components/text/staticText/purchaseContract.vue'], resolve),
                    meta: {
                        title: '采购合同',
                        requireAuth: false
                    }
                },
                {
                    path: 'serviceAgreement',
                    name: 'serviceAgreement',
                    component: resolve => require(['../components/text/staticText/serviceAgreement.vue'], resolve),
                    meta: {
                        title: '服务协议',
                        requireAuth: false
                    }
                },
                {
                    path: 'privacyPolicy',
                    name: 'privacyPolicy',
                    component: resolve => require(['../components/text/staticText/privacyPolicy.vue'], resolve),
                    meta: {
                        title: '隐私政策',
                        requireAuth: false
                    }
                },
                // 跨境  用户须知
                {
                    path: 'overSeaNotice',
                    name: 'overSeaNotice',
                    component: resolve => require(['../components/text/staticText/overSeaNotice.vue'], resolve),
                    meta: {
                        title: '用户须知',
                        requireAuth: false
                    }
                },
                // 跨境 服务协议
                {
                    path: 'overSeaPrivacy',
                    name: 'overSeaPrivacy',
                    component: resolve => require(['../components/text/staticText/overSeaPrivacy.vue'], resolve),
                    meta: {
                        title: '服务协议',
                        requireAuth: false
                    }
                },
                // 跨境 税费说明
                {
                    path: 'overSeaTax',
                    name: 'overSeaTax',
                    component: resolve => require(['../components/text/staticText/overSeaTax.vue'], resolve),
                    meta: {
                        title: ' 跨境电商综合税说明',
                        requireAuth: false
                    }
                },
                // 跨境 传输同意函
                {
                    path: 'overSeaConsent',
                    name: 'overSeaConsent',
                    component: resolve => require(['../components/text/staticText/overSeaConsent.vue'], resolve),
                    meta: {
                        title: '跨境传输同意函',
                        requireAuth: false
                    }
                },
                // 跨境 代理购结汇服务协议
                {
                    path: 'overSeaAgency',
                    name: 'overSeaAgency',
                    component: resolve => require(['../components/text/staticText/overSeaAgency.vue'], resolve),
                    meta: {
                        title: '代理购结汇服务协议',
                        requireAuth: false
                    }
                },
                {
                    path: 'cooperationAgreement',
                    name: 'cooperationAgreement',
                    component: resolve => require(['../components/text/staticText/cooperationAgreement.vue'], resolve),
                    meta: {
                        title: '合作协议',
                        requireAuth: false
                    }
                },
                {
                    path: 'privilegeProtocel',
                    name: 'privilegeProtocel',
                    component: resolve => require(['../components/text/staticText/privilegeProtocel.vue'], resolve),
                    meta: {
                        title: '会员服务协议',
                        requireAuth: false
                    }
                }
            ]
        },
        // 视频回放
        {
            path: '/livePlayback/:id',
            name: 'livePlayback',
            component: resolve => require(['../pages/information/livePlayback.vue'], resolve),
            meta: {
                title: '精彩回放',
                requireAuth: false,
                isShare: true
            }
        },
        //访谈海报
        {
            path: '/interview',
            name: 'interview',
            component: resolve => require(['../pages/live/interview.vue'], resolve),
            meta: {
                title: '访谈',
                requireAuth: false
            }
        },
        //直播
        {
            path: '/live',
            name: 'live',
            component: resolve => require(['../pages/live/live.vue'], resolve),
            meta: {
                title: '直播',
                requireAuth: false
            }
        },

        //限时抽奖规则
        {
            path: '/LiveLotteryRules',
            name: 'LiveLotteryRules',
            component: resolve => require(['../components/text/LiveLotteryRules.vue'], resolve),
            meta: {
                title: '活动规则',
                requireAuth: false
            }
        },
        {
            path: '/statistics',
            name: 'statistics',
            component: resolve => require(['../pages/statistics/index.vue'], resolve),
            meta: {
                title: '销售报表',
                requireAuth: false
            }
        },
        //观众，大屏投放页面
        {
            path: '/auctione',
            name: 'auctione',
            component: resolve => require(['../pages/bigScreen/auctione.vue'], resolve),
        },
        //拍卖师
        {
            path: '/auctioneer',
            name: 'auctioneer',
            component: resolve => require(['../pages/bigScreen/auctioneer.vue'], resolve),
        },
        //云品鉴直播
        {
            path: '/cloudLive',
            name: 'cloudLive',
            component: resolve => require(['../pages/live/cloudLive.vue'], resolve),
            meta: {
                title: '云品鉴·LIVE'
            }
        },
        //云品鉴直播进入详情
        {
            path: '/cloudDetails',
            name: 'cloudDetails',
            component: resolve => require(['../pages/live/cloudDetails.vue'], resolve),
            meta: {
                isShare: true
            }
        },


        {
            path: '*',
            name: 'error',
            component: resolve => require(['../pages/error/error'], resolve),
        },
        {
            path: '/blank',
            name: 'blank',
            component: resolve => require(['../pages/error/blank'], resolve),
        },
        //=====单桶=====
        {
            path: '/barrel',
            component: parentComponent,
            children: [{
                    path: 'barrelTable',
                    name: 'barrelTable',
                    component: resolve => require(['../pages/barrel/barrelTable.vue'], resolve),
                    meta: {
                        title: '众筹列表',
                        requireAuth: false
                    },
                },
                //单桶众筹详情
                {
                    path: 'crowdfundingDetails/:id',
                    name: 'crowdfundingDetails',
                    component: resolve => require(['../pages/barrel/crowdfundingDetails.vue'], resolve),
                    meta: {
                        title: '众筹详情',
                        isShare: true
                    }
                },

                //项目回报
                {
                    path: 'projectReturn/:id',
                    name: 'projectReturn',
                    component: resolve => require(['../pages/barrel/projectReturn.vue'], resolve),
                    meta: {
                        title: '项目回报',
                        isShare: false,
                        rightBtn: true,
                        rightBtnText: '众筹规则',
                        jsMethod: 'window.h5PushPage()'
                    }
                },
                //单桶定制详情
                {
                    path: 'customDetails/:id',
                    name: 'customDetails',
                    component: resolve => require(['../pages/barrel/customDetails.vue'], resolve),
                    meta: {
                        title: '定制详情',
                        isShare: true
                    }
                },
                //单桶拍卖
                {
                    path: 'barrelAuction/:id',
                    name: 'barrelAuction',
                    component: resolve => require(['../pages/barrel/barrelAuction.vue'], resolve),
                    meta: {
                        title: '拍品详情',
                        isShare: true
                    }
                },
                //单桶拍卖加价规则
                {
                    path: 'addAuctionRule',
                    name: 'addAuctionRule',
                    component: resolve => require(['../components/text/addAuctionRule.vue'], resolve),
                    meta: {
                        title: '加价规则',
                        isShare: true
                    }
                },
                //单桶拍卖出价记录
                {
                    path: 'AuctionRecording',
                    name: 'AuctionRecording',
                    component: resolve => require(['../pages/barrel/AuctionRecording.vue'], resolve),
                    meta: {
                        title: '加价规则',
                        isShare: true
                    }
                },

                //单桶定制合同
                {
                    path: 'customContract/:id',
                    name: 'customContract',
                    component: resolve => require(['../components/text/aboutSetting/barrel/customContract.vue'], resolve),
                },

            ]
        },
        //各种会员
        {
            path: '/VariousMembers',
            component: parentComponent,
            children: [
                //骑士会员首页
                // {
                //   path: 'KnightsMember',
                //   name: 'KnightsMember',
                //   component: resolve => require(['../pages/user/allMember/KnightsMember.vue'], resolve),
                //   meta: {
                //     title: '骑士团会员',
                //     isShare: true
                //   }
                // },
                {
                    path: 'knightsMember',
                    name: 'knightsMember',
                    component: resolve => require(['../pages/user/allMember/newKnightsMember.vue'], resolve),
                    meta: {
                        title: '会员中心',
                        hideTitle: false,
                        isShare: false
                    }
                },
                {
                    path: 'giftList/1',
                    name: 'giftList',
                    component: resolve => require(['../pages/user/allMember/giftList.vue'], resolve),
                    meta: {
                        title: '季卡礼品',
                        isShare: false,
                        type: 1
                    }
                },
                {
                    path: 'giftList/2',
                    name: 'giftList',
                    component: resolve => require(['../pages/user/allMember/giftList.vue'], resolve),
                    meta: {
                        title: '年卡大礼包',
                        isShare: false,
                        type: 2
                    }
                },
                {
                    path: 'giftList/3',
                    name: 'giftList',
                    component: resolve => require(['../pages/user/allMember/giftList.vue'], resolve),
                    meta: {
                        title: '生日好礼',
                        isShare: false,
                        type: 3
                    }
                },
                //团聊天
                {
                    path: 'GroupChat/:id',
                    name: 'GroupChat',
                    component: resolve => require(['../pages/user/allMember/GroupChat.vue'], resolve),
                    meta: {
                        title: '骑士团聊天',
                        isShare: true
                    }
                },
                //骑士团权益详情
                {
                    path: 'PrivilegeDetails',
                    name: 'PrivilegeDetails',
                    component: resolve => require(['../pages/user/allMember/PrivilegeDetails.vue'], resolve),
                    meta: {
                        title: '权益详情',
                        keepAlive: true,
                        isShare: false
                    }
                },
                //奖励金
                {
                    path: 'rewardMon',
                    name: 'rewardMon',
                    component: resolve => require(['../pages/user/allMember/rewardMon.vue'], resolve),
                    meta: {
                        title: '奖励金',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'RewardRules',
                    name: 'RewardRules',
                    component: resolve => require(['../pages/user/allMember/RewardRules.vue'], resolve),
                    meta: {
                        title: '奖励金规则',
                        requireAuth: true,
                        keepAlive: true
                    }
                },

                //骑士规则
                {
                    path: 'knightRule',
                    name: 'knightRule',
                    component: resolve => require(['../components/text/knightRule.vue'], resolve),
                    meta: {
                        title: '骑士团规则',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'vipRules',
                    name: 'vipRules',
                    component: resolve => require(['../components/text/vipRules.vue'], resolve),
                    meta: {
                        title: 'VIP认证规则',
                        requireAuth: true,
                        keepAlive: true
                    }
                },
                {
                    path: 'NotSpelledWell',
                    name: 'NotSpelledWell',
                    component: resolve => require(['../pages/user/allMember/NotSpelledWell.vue'], resolve),
                    meta: {
                        title: '即将成团',
                        isShare: true
                    }
                },
                {
                    path: 'knightList/:id',
                    name: 'knightList',
                    component: resolve => require(['../pages/user/allMember/knightList.vue'], resolve),
                    meta: {
                        title: '',
                        isShare: true
                    }
                },

            ]
        }
        // 下面是嵌套路由、动态路由示例-------------------------------start
        /*    {
        		path: 'a',
        		name: 'a',
        		component: parentComponent,
        		children: [
        			{
        				path: 'b',
        				component: parentComponent,
        				children: [{
        						path: customDetailsTxt'',
        						name: 'c',
        						component: resolve => require(['ccc'], resolve),
        					},
        					{
        						path: 'd',
        						name: 'd',
        						component: resolve => require(['ddd'], resolve),
        					},
        					// 动态路由示例
        					{
        						path: 'e/:id',
        						name: 'e',
        						component: resolve => require(['eee'], resolve),
        					}
        				]
        			},
        		]
        	},
        */
        // ----------------------------------------------------------------------end
    ],
})



// WEBPACK FOOTER //
// ./src/router/index.js